import { Ptag } from "components/core";
import React from "react";
import { getAttributeIcon } from "utlis/utils";

const GradeSimpleDetail = ({ title, children, style }) => {
  return (
    <section style={{ maxWidth: "110ch", marginBottom: "30px", ...style }}>
      <header
        style={{
          display: "flex",
          gap: "8px",
          alignItems: "center",
          marginBottom: "24px"
        }}
      >
        <img src={getAttributeIcon(title)} alt="icon" />
        <Ptag fontWeight="600" fontSize="20px" color="#4a4a4a">
          {title}
        </Ptag>
      </header>
      {children}
    </section>
  );
};

export default GradeSimpleDetail;
